export const scrollToTop = (isSmooth?: boolean) => {
  isSmooth ?
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    }) :
    window.scrollTo(0, 0);
}
